export default __webpack_public_path__ + "static/media/instagram.a0b6eb5e.png";